@let wizardHost = wizard();
<div class="flex min-w-0 flex-col gap-3">
  @if (wizardHost.productStepPanel() === "catalog") {
    @if (wizardHost.productsStepMissingLines()) {
      <p class="rounded-lg border border-destructive/25 bg-destructive/5 px-3 py-2 text-sm text-destructive">
        {{ "mobile.eachat.wizard.productsValidation" | translate }}
      </p>
    }

    @if (wizardHost.productAddHintKey(); as hint) {
      @if (hint === "quantity") {
        <p class="text-xs text-destructive">{{ "mobile.eachat.wizard.productNeedQuantity" | translate }}</p>
      } @else if (hint === "unit") {
        <p class="text-xs text-destructive">{{ "mobile.eachat.wizard.productNeedUnit" | translate }}</p>
      }
    }

    <div class="flex min-w-0 items-center gap-2 pr-2">
      <input
        type="search"
        name="productCatalogSearch"
        class="min-h-[44px] min-w-0 max-w-[80%] flex-1 rounded-full border border-[#ece4f3] bg-[#faf7fc] px-3 py-2 text-sm text-[#3d2652] placeholder:text-[#a49db0]"
        [placeholder]="'mobile.eachat.wizard.productSearchPlaceholder' | translate"
        [ngModel]="wizardHost.productSearchSig()"
        (ngModelChange)="wizardHost.onProductSearchChange($event)"
        [ngModelOptions]="{ standalone: true }"
        autocomplete="off"
      />
      <button
        type="button"
        class="relative inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#ece4f3] bg-white text-[#5a2f6b] shadow-sm active:bg-[#faf7fc]"
        (click)="wizardHost.openProductSelectionPanel()"
        [attr.aria-label]="'mobile.eachat.wizard.openSelectionAria' | translate"
      >
        <span class="material-icons text-[22px]" aria-hidden="true">shopping_cart</span>
        @if (wizardHost.deliveryCartCount(); as c) {
          @if (c > 0) {
            <span
              class="absolute -right-0.5 -top-0.5 flex h-[16px] min-w-[16px] items-center justify-center rounded-full bg-red-500 px-0.5 text-[0.58rem] font-bold leading-none text-white"
              aria-hidden="true"
              >{{ c }}</span
            >
          }
        }
      </button>
    </div>

    <p class="text-xs tabular-nums text-[#94a3b8]">
      {{ "mobile.eachat.wizard.productResultsCount" | translate }} :
      {{ wizardHost.productCatalogList().length }}
    </p>

    @if (wizardHost.productCatalogLoading()) {
      <div class="flex justify-center py-10">
        <span class="material-icons animate-spin text-[#5a2f6b]" aria-hidden="true">progress_activity</span>
      </div>
    } @else if (!wizardHost.productCatalogList().length) {
      <p class="rounded-xl border border-dashed border-[#ece4f3] bg-[#faf7fc] px-3 py-6 text-center text-sm text-[#7a6b8a]">
        {{ "mobile.eachat.wizard.productCatalogEmpty" | translate }}
      </p>
    } @else {
      <ul class="flex flex-col gap-2.5">
        @for (catalogProduct of wizardHost.productCatalogList(); track productCatalogTrack($index, catalogProduct)) {
          @let productUid = wizardHost.catalogProductUid(catalogProduct);
          @let productRowDraft = productUid ? wizardHost.getProductRowDraft(productUid) : { quantity: 1, unitUid: "" };
          <li class="min-w-0 rounded-xl border border-[#ece4f3] bg-white p-3 shadow-sm">
            <div class="flex gap-2">
              <div class="min-w-0 flex-1">
                <p class="text-sm font-semibold leading-snug text-[#1a1523]">
                  {{ catalogProduct.Label?.trim() || ("mobile.eachat.list.unnamed" | translate) }}
                </p>
                @if (catalogProduct.SKUCode?.trim(); as skuCode) {
                  <p class="mt-0.5 font-mono text-[0.7rem] text-[#7a6b8a]">{{ skuCode }}</p>
                }
              </div>
              <div class="flex shrink-0 items-center gap-2">
                <button
                  type="button"
                  class="inline-flex h-10 w-10 items-center justify-center rounded-full border border-[#ece4f3] bg-white text-[#5a2f6b] shadow-sm disabled:opacity-35"
                  [disabled]="!productUid"
                  (click)="openProductDetail(catalogProduct, $event)"
                  [attr.title]="'app.shared.consult' | translate"
                  [attr.aria-label]="'app.shared.consult' | translate"
                >
                  <span class="material-icons text-[21px]" aria-hidden="true">visibility</span>
                </button>
                <button
                  type="button"
                  class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#5a2f6b] text-white shadow-sm active:opacity-90 disabled:opacity-35"
                  [disabled]="!productUid"
                  (click)="wizardHost.addCatalogProductLine(catalogProduct)"
                  [attr.title]="'mobile.eachat.wizard.addLineTitle' | translate"
                  [attr.aria-label]="'mobile.eachat.wizard.addLineTitle' | translate"
                >
                  <span class="material-icons text-[22px]" aria-hidden="true">add_shopping_cart</span>
                </button>
              </div>
            </div>
            @if (productUid; as selectedProductUid) {
              <div class="mt-3 grid min-w-0 grid-cols-[minmax(0,7.5rem)_minmax(0,1fr)] gap-2">
              <label class="flex max-w-full flex-col gap-1 self-start">
                <span class="text-[0.65rem] font-semibold uppercase tracking-wide text-[#7a6b8a]">{{
                  "mobile.eachat.field.quantity" | translate
                }}</span>
                <div
                  class="flex h-10 w-[7.5rem] max-w-full items-stretch overflow-hidden rounded-full border border-[#ece4f3] bg-[#faf7fc]"
                >
                  <button
                    type="button"
                    class="flex w-9 shrink-0 touch-manipulation items-center justify-center border-r border-[#ece4f3] text-[#5a2f6b] active:bg-[#ece4f3]/80 disabled:opacity-35"
                      [disabled]="productRowDraft.quantity <= 1"
                      (click)="wizardHost.bumpCatalogProductDraftQuantity(selectedProductUid, -1)"
                    [attr.aria-label]="'mobile.eachat.wizard.quantityDecrease' | translate"
                  >
                    <span class="material-icons text-[22px]" aria-hidden="true">chevron_left</span>
                  </button>
                  <input
                    type="number"
                    min="1"
                    step="1"
                    inputmode="numeric"
                    class="min-h-0 min-w-0 flex-1 border-0 bg-transparent px-1 py-0 text-center text-sm tabular-nums text-[#1a1523] [appearance:textfield] focus:outline-none focus:ring-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
                    [ngModel]="productRowDraft.quantity"
                      (ngModelChange)="wizardHost.patchProductRowDraft(selectedProductUid, { quantity: wizardHost.parseQuantityInput($event) })"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <button
                    type="button"
                    class="flex w-9 shrink-0 touch-manipulation items-center justify-center border-l border-[#ece4f3] text-[#5a2f6b] active:bg-[#ece4f3]/80 disabled:opacity-35"
                      (click)="wizardHost.bumpCatalogProductDraftQuantity(selectedProductUid, 1)"
                    [attr.aria-label]="'mobile.eachat.wizard.quantityIncrease' | translate"
                  >
                    <span class="material-icons text-[22px]" aria-hidden="true">chevron_right</span>
                  </button>
                </div>
              </label>
                <div class="flex min-w-0 flex-col gap-1">
                <span class="text-[0.65rem] font-semibold uppercase tracking-wide text-[#7a6b8a]">{{
                  "mobile.eachat.wizard.unitLabel" | translate
                }}</span>
                  <details
                    #catalogUnitDd
                    class="relative min-w-0 w-full [&_summary::-webkit-details-marker]:hidden"
                  >
                    <summary
                      class="flex min-h-[40px] w-full min-w-0 cursor-pointer list-none items-center gap-2 rounded-full border border-[#ece4f3] bg-[#faf7fc] px-3 py-2 text-sm touch-manipulation"
                    >
                      @if (unitDisplayName(productRowDraft.unitUid); as unitName) {
                        <span class="min-w-0 flex-1 truncate text-[#1a1523]">{{ unitName }}</span>
                      } @else {
                        <span class="min-w-0 flex-1 truncate text-[#9a929e]">{{
                          "mobile.eachat.wizard.selectUnit" | translate
                        }}</span>
                      }
                      <span class="material-icons shrink-0 text-[20px] text-[#5a2f6b]" aria-hidden="true">expand_more</span>
                    </summary>
                    <ul
                      class="absolute left-0 right-0 top-full z-30 mt-1 max-h-40 overflow-y-auto overscroll-contain rounded-xl border border-[#cfd1dc] bg-white py-1 shadow-lg"
                      role="listbox"
                    >
                      <li role="none">
                        <button
                          type="button"
                          role="option"
                          class="flex w-full min-w-0 items-center px-3 py-2.5 text-left text-sm text-[#9a929e] active:bg-[#f5f0fa]"
                          [class.bg-[#eee6f5]]="!productRowDraft.unitUid"
                          (click)="pickCatalogUnit(catalogUnitDd, selectedProductUid, '')"
                        >
                          <span class="min-w-0 flex-1 truncate">{{ "mobile.eachat.wizard.selectUnit" | translate }}</span>
                        </button>
                      </li>
                  @for (unitOption of wizardHost.sortedUnits(); track unitOptionTrack($index, unitOption)) {
                    @if (unitOption.Uid != null) {
                          @let unitUid = wizardHost.unitUidStr(unitOption);
                          <li role="none">
                            <button
                              type="button"
                              role="option"
                              class="flex w-full min-w-0 items-center gap-2 px-3 py-2.5 text-left text-sm active:bg-[#f5f0fa]"
                              [class.bg-[#eee6f5]]="isUnitRowSelected(unitUid, productRowDraft.unitUid)"
                              (click)="pickCatalogUnit(catalogUnitDd, selectedProductUid, unitUid)"
                            >
                              <span class="min-w-0 flex-1 truncate font-medium text-[#1a1523]">{{ unitOption.Name ?? "—" }}</span>
                              @if (isUnitRowSelected(unitUid, productRowDraft.unitUid)) {
                                <span class="material-icons shrink-0 text-[18px] text-[#5a2f6b]" aria-hidden="true">check</span>
                              }
                            </button>
                          </li>
                        }
                      }
                    </ul>
                  </details>
                </div>
            </div>
            }
            @if (hasLinkedSuppliers(catalogProduct)) {
              <div class="mt-3 flex items-center justify-between gap-3 border-t border-[#f3edf8] pt-3">
                <span class="text-[0.68rem] font-semibold uppercase tracking-wide text-[#7a6b8a]">
                  {{ "app.product.supplier" | translate }}
                </span>
                <div class="flex min-w-0 items-center justify-end pl-2">
                  @for (supplierLabel of productSupplierPreviewLabels(catalogProduct); track supplierLabel) {
                    <span
                      class="-ml-2 inline-flex h-7 min-w-[1.75rem] shrink-0 items-center justify-center rounded-full px-1 text-[0.62rem] font-bold text-white shadow-sm ring-2 ring-white first:ml-0"
                      [style.background-color]="supplierAvatarBackground(supplierLabel)"
                      [attr.aria-label]="supplierLabel"
                    >
                      {{ supplierInitials(supplierLabel) }}
                    </span>
                  }
                  @if (productSupplierOverflowCount(catalogProduct) > 0) {
                    <span
                      class="-ml-2 inline-flex h-7 min-w-[1.75rem] shrink-0 items-center justify-center rounded-full bg-[#ece4f3] px-1 text-[0.62rem] font-bold text-[#5a2f6b] ring-2 ring-white"
                    >
                      +{{ productSupplierOverflowCount(catalogProduct) }}
                    </span>
                  }
                </div>
              </div>
            }
          </li>
        }
      </ul>
      @if (wizardHost.productCatalogHasMore() && wizardHost.productCatalogList().length && !wizardHost.productCatalogLoading()) {
        <button
          type="button"
          class="w-full rounded-xl border border-[#ece4f3] bg-white py-2.5 text-sm font-semibold text-[#5a2f6b] disabled:opacity-60"
          [disabled]="wizardHost.productCatalogLoadingMore()"
          (click)="wizardHost.loadMoreProductCatalog()"
        >
          {{
            (wizardHost.productCatalogLoadingMore() ? "common.loading" : "mobile.voicePurchaseRequest.providers.loadMore")
              | translate
          }}
        </button>
      }
    }
  } @else {
    <div class="flex flex-col gap-3">
      <div class="flex items-center gap-2">
        <button
          type="button"
          class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#ece4f3] bg-white text-[#5a2f6b]"
          (click)="wizardHost.closeProductSelectionPanel()"
          [attr.aria-label]="'mobile.eachat.wizard.backToCatalog' | translate"
        >
          <span class="material-icons" aria-hidden="true">arrow_back</span>
        </button>
        <div class="min-w-0 flex-1">
          <p class="text-base font-semibold text-[#3d2652]">
            {{ "mobile.eachat.wizard.selectionTitle" | translate }}
          </p>
        </div>
      </div>

      @if (wizardHost.selectionHydrating()) {
        <div class="flex items-center gap-2 rounded-lg border border-[#ece4f3] bg-[#faf7fc] px-3 py-2 text-xs text-[#7a6b8a]">
          <span class="material-icons animate-spin text-[18px] text-[#5a2f6b]" aria-hidden="true">progress_activity</span>
          {{ "mobile.eachat.wizard.selectionLoading" | translate }}
        </div>
      }

      @if (!wizardHost.deliveryProducts().length) {
        <p class="rounded-xl border border-dashed border-[#ece4f3] bg-[#faf7fc] px-3 py-6 text-center text-sm text-[#7a6b8a]">
          {{ "mobile.eachat.wizard.selectionEmpty" | translate }}
        </p>
      } @else {
        <ul class="flex flex-col gap-2.5">
          @for (deliveryProduct of wizardHost.deliveryProducts(); track selectionLineTrack($index, deliveryProduct)) {
            <li class="min-w-0 rounded-xl border border-[#ece4f3] bg-white p-3 shadow-sm">
              @if (deliveryProduct.ProductUid) {
                <div class="flex gap-2">
                  <div class="min-w-0 flex-1">
                    <p class="text-sm font-semibold leading-snug text-[#1a1523]">
                      {{ wizardHost.mobileDeliveryProductTitle(deliveryProduct) }}
                    </p>
                    @if (wizardHost.mobileDeliveryProductSubtitle(deliveryProduct)) {
                      <p class="mt-0.5 font-mono text-[0.7rem] text-[#7a6b8a]">
                        {{ wizardHost.mobileDeliveryProductSubtitle(deliveryProduct) }}
                      </p>
                    }
                  </div>
                  <button
                    type="button"
                    class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#5a2f6b] text-white shadow-sm active:opacity-90"
                    (click)="wizardHost.removeDeliveryProductLine(deliveryProduct.ProductUid)"
                    [attr.title]="'mobile.eachat.wizard.removeLineAria' | translate"
                    [attr.aria-label]="'mobile.eachat.wizard.removeLineAria' | translate"
                  >
                    <span class="material-icons text-[22px]" aria-hidden="true">delete_outline</span>
                  </button>
                </div>
                @let selectedUnitUid = wizardHost.selectionLineUnitValue(deliveryProduct);
                <div class="mt-3 grid min-w-0 grid-cols-[minmax(0,7.5rem)_minmax(0,1fr)] gap-2">
                  <label class="flex max-w-full flex-col gap-1 self-start">
                    <span class="text-[0.65rem] font-semibold uppercase tracking-wide text-[#7a6b8a]">{{
                      "mobile.eachat.field.quantity" | translate
                    }}</span>
                    <div
                      class="flex h-10 w-[7.5rem] max-w-full items-stretch overflow-hidden rounded-full border border-[#ece4f3] bg-[#faf7fc]"
                    >
                      <button
                        type="button"
                        class="flex w-9 shrink-0 touch-manipulation items-center justify-center border-r border-[#ece4f3] text-[#5a2f6b] active:bg-[#ece4f3]/80 disabled:opacity-35"
                        [disabled]="(deliveryProduct.Quantity ?? 1) <= 1"
                        (click)="wizardHost.adjustSelectionLineQuantity(deliveryProduct, -1)"
                        [attr.aria-label]="'mobile.eachat.wizard.quantityDecrease' | translate"
                      >
                        <span class="material-icons text-[22px]" aria-hidden="true">chevron_left</span>
                      </button>
                      <input
                        type="number"
                        min="1"
                        step="1"
                        inputmode="numeric"
                        class="min-h-0 min-w-0 flex-1 border-0 bg-transparent px-1 py-0 text-center text-sm tabular-nums text-[#1a1523] [appearance:textfield] focus:outline-none focus:ring-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
                        [ngModel]="deliveryProduct.Quantity ?? 1"
                        (ngModelChange)="wizardHost.updateSelectionLineQuantity(deliveryProduct, $event)"
                        [ngModelOptions]="{ standalone: true }"
                      />
                      <button
                        type="button"
                        class="flex w-9 shrink-0 touch-manipulation items-center justify-center border-l border-[#ece4f3] text-[#5a2f6b] active:bg-[#ece4f3]/80"
                        (click)="wizardHost.adjustSelectionLineQuantity(deliveryProduct, 1)"
                        [attr.aria-label]="'mobile.eachat.wizard.quantityIncrease' | translate"
                      >
                        <span class="material-icons text-[22px]" aria-hidden="true">chevron_right</span>
                      </button>
                    </div>
                  </label>
                  <div class="flex min-w-0 flex-col gap-1">
                    <span class="text-[0.65rem] font-semibold uppercase tracking-wide text-[#7a6b8a]">{{
                      "mobile.eachat.wizard.unitLabel" | translate
                    }}</span>
                    <details
                      #selectionUnitDd
                      class="relative min-w-0 w-full [&_summary::-webkit-details-marker]:hidden"
                    >
                      <summary
                        class="flex min-h-[40px] w-full min-w-0 cursor-pointer list-none items-center gap-2 rounded-full border border-[#ece4f3] bg-[#faf7fc] px-3 py-2 text-sm touch-manipulation"
                      >
                        @if (unitDisplayName(selectedUnitUid); as unitName) {
                          <span class="min-w-0 flex-1 truncate text-[#1a1523]">{{ unitName }}</span>
                        } @else {
                          <span class="min-w-0 flex-1 truncate text-[#9a929e]">{{
                            "mobile.eachat.wizard.selectUnit" | translate
                          }}</span>
                        }
                        <span class="material-icons shrink-0 text-[20px] text-[#5a2f6b]" aria-hidden="true">expand_more</span>
                      </summary>
                      <ul
                        class="absolute left-0 right-0 top-full z-30 mt-1 max-h-40 overflow-y-auto overscroll-contain rounded-xl border border-[#cfd1dc] bg-white py-1 shadow-lg"
                        role="listbox"
                      >
                        <li role="none">
                          <button
                            type="button"
                            role="option"
                            class="flex w-full min-w-0 items-center px-3 py-2.5 text-left text-sm text-[#9a929e] active:bg-[#f5f0fa]"
                            [class.bg-[#eee6f5]]="!selectedUnitUid"
                            (click)="pickSelectionUnit(selectionUnitDd, deliveryProduct, '')"
                          >
                            <span class="min-w-0 flex-1 truncate">{{ "mobile.eachat.wizard.selectUnit" | translate }}</span>
                          </button>
                        </li>
                      @for (unitOption of wizardHost.sortedUnits(); track unitOptionTrack($index, unitOption)) {
                        @if (unitOption.Uid != null) {
                            @let unitUid = wizardHost.unitUidStr(unitOption);
                            <li role="none">
                              <button
                                type="button"
                                role="option"
                                class="flex w-full min-w-0 items-center gap-2 px-3 py-2.5 text-left text-sm active:bg-[#f5f0fa]"
                                [class.bg-[#eee6f5]]="isUnitRowSelected(unitUid, selectedUnitUid)"
                                (click)="pickSelectionUnit(selectionUnitDd, deliveryProduct, unitUid)"
                              >
                                <span class="min-w-0 flex-1 truncate font-medium text-[#1a1523]">{{ unitOption.Name ?? "—" }}</span>
                                @if (isUnitRowSelected(unitUid, selectedUnitUid)) {
                                  <span class="material-icons shrink-0 text-[18px] text-[#5a2f6b]" aria-hidden="true">check</span>
                                }
                              </button>
                            </li>
                          }
                        }
                      </ul>
                    </details>
                  </div>
                </div>
              } @else {
                <div class="flex gap-3">
                  <div class="min-w-0 flex-1">
                    <p class="text-sm font-semibold text-[#1a1523]">{{ wizardHost.mobileDeliveryProductTitle(deliveryProduct) }}</p>
                    @if (wizardHost.mobileDeliveryProductSubtitle(deliveryProduct)) {
                      <p class="mt-0.5 font-mono text-[0.7rem] text-[#7a6b8a]">
                        {{ wizardHost.mobileDeliveryProductSubtitle(deliveryProduct) }}
                      </p>
                    }
                  </div>
                </div>
              }
            </li>
          }
        </ul>
      }
    </div>
  }
</div>
